import { render } from "./App.vue?vue&type=template&id=145699d5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=145699d5&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__